import { useState } from 'react';
import classNames from 'classnames';
import { THEMES } from './themes';
import { useTheme } from './ThemeProvider';
import styles from './ThemeSwitcher.module.scss';

export const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <span className={styles.swatch} aria-hidden="true" />
        Look: {theme.name}
      </button>
      {open ? (
        <ul className={styles.menu} role="menu" aria-label="Choose a look">
          {THEMES.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                role="menuitemradio"
                aria-checked={item.id === theme.id}
                className={classNames(styles.item, { [styles.active]: item.id === theme.id })}
                onClick={() => {
                  setTheme(item.id);
                  setOpen(false);
                }}
              >
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemTagline}>{item.tagline}</span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
